__turbopack_context__.v({
  "actions": "FirstConnectionEmptyState-module__byslqG__actions",
  "copy": "FirstConnectionEmptyState-module__byslqG__copy",
  "root": "FirstConnectionEmptyState-module__byslqG__root",
});
